import MinMaxTest from "./MinMaxTest";
import GammaTest from "./GammaTest";
import Blend from "./Blend";
import SvgImageFilter from "./SvgImageFilter";
import { computeFilterArgs } from './SvgImageFilter';
import O from "./O";
import G from './Getters';
import { useStore } from 'react-redux';

import che7 from './images/7.jpeg';
import che51 from './images/51.jpeg';
import che52 from './images/52.jpeg';
import che53 from './images/53.jpeg';
import che54 from './images/54.jpeg';
import che35 from './images/35.jpeg';
import che36 from './images/36.jpeg';


const imageList = [che7];//, che51, che52, che53, che54, che35, che36];

export default function VirtualImagePreview(){


  const store = useStore();
  const state = store.getState();

  let imageId = "v_t=i;merge=c1.jpeg,c2.jpeg,c3.jpeg;proj=yellow,cyan,magenta";

  let entries = imageId.split(';').map(prop => prop.split('=')).map(([key,rawValString]) => {
    let commaSplit = rawValString.split(',');
    let { length } = commaSplit;
    if( length === 1 ){
      return [key,rawValString]
    }else{
      return [key,commaSplit];
    }
  })
    
  let obj = Object.fromEntries(entries);

  let { merge, proj } = obj;

  let imageInfo = merge.map((imageId,ii) => {
    return {
      color:proj[ii],
      imageId,
      url:G.getImageRecordUrl(state,{imageId})
    }
  })

  const inlineCrop = {
    left:0,
    top:0,
    width:1,
    height:1,
    rotation:0,
  }

  let atnId = `v_t=atn;geo=full;is=${"_c1-is"}`

  const contrast = 1.5;
  const svgContrast = 2;

  const brightness = 5;
  const slope = contrast;// * 2;
  const intercept = -0.5 * contrast + 0.5;



  let temporaryAdjustments = {
    contrast,
    brightness,
  }

  const w = 500;

  /*
  let cd = false && (

    <CropDisplay 
          temporaryAdjustments={
            temporaryAdjustments
          }
          width={w} 
          annotationId={atnId} 
          imageId={"c1.jpeg"}/>
  )

  let cdRaw =  false && (

    <CropDisplay 
          width={w} 
          annotationId={atnId} 
          imageId={"c1.jpeg"}/>
  )
  */

  let filterArgs = computeFilterArgs(
              temporaryAdjustments
            )


  const filterId = "my-test-filter";
  filterArgs.filterId = filterId;
  let gammas = [0.2,0.5,1,2,3,4,5]

  let mins = [0,0.5,0.75,0.8,0.9]

  let imageUrls = Object.values(state.media).map(item => item.raw.localBlobUrl);


    return (
      <div>
        <div class="sg-row">
          {/*false && cd*/}


      {true && <svg class="outline" style={{
          width:w,
          height:w,
        }}>

          {true && <SvgImageFilter {...{
            filterArgs
          }}/>}

          <foreignObject 
            filter={`url(#${filterId})`}
            stroke={"red"} width="100%" height="100%">
            {/*false && cdRaw*/}
          </foreignObject>
        </svg>}

        


        </div>




        <div class="sg-row">

          
          {/*false && <ImagePreview/>*/}


        </div>

      <O>{obj}</O>
        

        <div class="sg-row">
          {imageUrls.filter(x => x.includes('broad')).map(x => <img style={{ width:200}}src={x}/>)}

          <Blend images={imageUrls}/>
        </div>

          <div class="sg-row">
          {imageList.map(x => <MinMaxTest {...{url:x}}/>)}
          </div>

      {gammas.map(gamma => {
        return (
          <div class="sg-row">
          {imageList.map(x => <GammaTest key={Math.random()} {...{url:x,gamma}}/>)}
          </div>
        )
      })}

        

        
      </div>
    )
  


}
